// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".premainloader[data-v-32c4d38d]{position:fixed;width:100vw;height:100vh;background-color:#f5f5f5}", ""]);
// Exports
module.exports = exports;
